// eslint-disable-line max-lines
import React from 'react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Card, Icon, Popup, Button, Select} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {downloadFile} from '../../../common/util/file';
import Loader from '../../../common/components/loader';
import CalendarAirBnb from '../../../common/components/CalendarAirBnb';
import moment from 'moment';
import './tccList.scss';
import HeaderLogo from '../../common/HeaderLogo';
import {DATEFORMAT} from '../../constants';
import ListTccTable from './Table';

const WIDTH_ROW = 120;
const dateFormat = 'DD-MM-YYYY';

const OPTIONS_TYPE_REQUEST = [
  {'key': 'TODAS', 'value': 'TODAS', 'text': 'TODAS'},
  {'key': 'CPO', 'value': 'CPO', 'text': 'CPO'},
  {'key': 'Garantía', 'value': 'Garantía', 'text': 'GARANTĪA'},
];

class ListVehiclesCertification extends React.Component {
  state = {
    'typeRequest': 'TODAS',
    'columns': [
      {
        'Header': 'NO.',
        'accessor': 'vehCertId',
      },
      {
        'Header': 'TIPO DE SOLICITUD',
        'accessor': 'typeForm',
        'Cell': (cell) => {
          const typeForm = cell.row.original.typeForm;
          return <span>{typeForm.toUpperCase()}</span>;
        },
      },
      {
        'Header': 'FECHA DE INGRESO',
        'accessor': 'vehCertDate',
        'width': WIDTH_ROW + 20,
      },
      {
        'Header': 'FECHA DE MODIFICACIÓN',
        'accessor': 'modificationDate',
        'width': WIDTH_ROW + 50,
      },
      {
        'Header': 'FECHA DE EXPIRACIÓN (GARANTÍA)',
        'accessor': 'guaranteeDate',
        'width': WIDTH_ROW + 50,
      },
      {
        'Header': 'CONCESIONARIO',
        'accessor': 'dealerId',
      },
      {
        'Header': 'CHASIS',
        'accessor': 'chasis',
        'width': WIDTH_ROW + 50,
      },
      {
        'Header': 'ASESOR',
        'accessor': 'vehCertUser',
        'width': WIDTH_ROW,
      },
      {
        'Header': 'APROBADO POR',
        'accessor': 'aprobeUser',
        'width': WIDTH_ROW,
      },
      {
        'Header': 'MODELO',
        'accessor': 'modelDescription',
      },
      {
        'Header': 'OBSERVACIÓN',
        'accessor': 'aprobeArgument',
        'Cell': (cell) => {
          const arg = cell.row.original.aprobeArgument;
          return (arg && <Popup content={arg}
            trigger={<p style={{'cursor': 'pointer'}}> {arg.slice(0, 30)} ... </p>} />) || null;
        },
      },
      {
        'Header': 'ESTADO',
        'accessor': 'status',
        'Filter': ({
          'column': {filterValue, setFilter},
        }) => {
          return (
            <select
              style={{'margin': '5px'}}
              className="select-vehicles-maintenance"
              value={filterValue}
              onChange={(e) => {
                setFilter(e.target.value || null);
              }}
            >
              <option value="">TODOS</option>
              {this.renderOptionState()}
            </select>
          );
        },
        'width': WIDTH_ROW,
      },
      {
        'Header': 'VISUALIZAR',
        'accessor': 'state',

        'Cell': (cell) => {
          const id = cell.row.original.chasis;
          return (
            <Link to={`/cpo/${id}`} state={{'typeForm': cell.row.original.typeForm}}>
              <Icon name="eye" size="large" />
            </Link>
          );
        },
        'width': WIDTH_ROW - 20,
      },
      {
        'Header': 'DOCUMENTO',
        'accessor': 'document',
        'Cell': (cell) => {
          const status = cell.row.original.status;
          const id = cell.row.original.vehCertId;
          const {pdf, loadingPdf, idRequest} = this.props;
          if (status === 'APROBADO' || status === 'VENDIDO') {
            return <React.Fragment>
              {pdf && !loadingPdf && id === idRequest ?
                <Button size={'small'} color='blue' onClick={() => downloadFile(pdf)}>
                  <Icon style={{'marginLeft': '5px'}} name="download" />
                </Button> :
                <React.Fragment>
                  {!loadingPdf ?
                    <Button size={'small'} onClick={() => this.handlePdf(id)}>
                      <Icon style={{'marginLeft': '5px'}} name="download" />
                    </Button> :
                    <Button size={'small'}>
                     ...
                    </Button>
                  }
                </React.Fragment>
              }
                 
            </React.Fragment>;
          }
          return null;
        },
        'width': WIDTH_ROW - 20,
      },
      {
        'Header': 'CERTIFICADO',
        'accessor': 'certificate',
        'Cell': (cell) => {
          const status = cell.row.original.status;
          const id = cell.row.original.vehCertId;
          const typeForm = cell.row.original.typeForm;
          const {pdfCertificate, loadingCertificate, idRequestCertificate} = this.props;
          if ((status === 'APROBADO' || status === 'VENDIDO') && typeForm === 'CPO') {
            return <React.Fragment>
              {pdfCertificate && !loadingCertificate && id === idRequestCertificate ?
                <Button size={'small'} color='blue' onClick={() => downloadFile(pdfCertificate)}>
                  <Icon style={{'marginLeft': '5px'}} name="download" />
                </Button> :
                <React.Fragment>
                  {!loadingCertificate ?
                    <Button size={'small'} onClick={() => this.handleCertificateOwnerPdf(id)}>
                      <Icon style={{'marginLeft': '5px'}} name="download" />
                    </Button> :
                    <Button size={'small'}>
                     ...
                    </Button>
                  }
                </React.Fragment>
              }
            </React.Fragment>;
          }
          return null;
        },
        'width': WIDTH_ROW - 20,
      },
      {
        'Header': 'LABEL',
        'accessor': 'label',
        'Cell': (cell) => {
          const status = cell.row.original.status;
          const id = cell.row.original.vehCertId;
          const {cpoLabel, loadingLabel, idLabel} = this.props;
          const typeForm = cell.row.original.typeForm;
          if ((status === 'APROBADO' || status === 'VENDIDO') && typeForm === 'CPO') {
            return <React.Fragment>
              {cpoLabel && !loadingLabel && id === idLabel ?
                <Button size={'small'} color='blue' onClick={() => downloadFile(cpoLabel)}>
                  <Icon style={{'marginLeft': '5px'}} name="download" />
                </Button> :
                <React.Fragment>
                  {!loadingLabel ?
                    <Button size={'small'} onClick={() => this.handleLabel(id)}>
                      <Icon style={{'marginLeft': '5px'}} name="download" />
                    </Button> :
                    <Button size={'small'}>
                      ...
                    </Button>
                  }
                </React.Fragment>
              }
            </React.Fragment>;
          }
          return null;
        },
        'width': WIDTH_ROW - 20,
      },
    ],
    'startDate': moment(`01-01-${moment().year()}`, DATEFORMAT).startOf('month'),
    'endDate': moment().endOf('month'),
    'id': null,
    'idCert': null,
    'idLabel': null,
  };

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ListVehiclesCertification, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    const start = moment(`01-01-${moment().year()}`, DATEFORMAT).startOf('month').format(DATEFORMAT);
    const end = moment().endOf('month').format(DATEFORMAT);
    this.props.getListVehCerticate(start, end);
  }

  handlePdf = (id) => {
    this.handleClear();
    this.props.getPdfCertificate(id);
    this.setState({id, 'idCert': null, 'idLabel': null});
  }

  handleLabel = (id) => {
    this.handleClear();
    this.props.getCpoLabel(id);
    this.setState({'id': null, 'idCert': null, 'idLabel': id});
  }

  handleCertificateOwnerPdf = (id) => {
    this.handleClear();
    this.props.getCertificateOwner(id);
    this.setState({'idCert': id, 'id': null, 'idLabel': null});
  }

  handleClear = () => {
    this.props.clearPdf();
    this.props.clearPdfOwner();
    this.props.clearCpoLabel();
  }

  handleDatesChange = ({startDate, endDate}) => {
    const {typeRequest} = this.state;
    this.setState({startDate, endDate});
    if (startDate && endDate) {
      const start = moment(startDate, DATEFORMAT).format(dateFormat);
      const end = moment(endDate, DATEFORMAT)
        .add(1, 'day')
        .format(dateFormat);
      this.props.getListVehCerticate(start, end, typeRequest);
    }
  };

  renderOptionState() {
    return (
      <React.Fragment>
        <option value="APROBADO">APROBADO</option>
        <option value="ENVIADO">ENVIADO</option>
        <option value="INGRESADO">INGRESADO</option>
        <option value="RECHAZADO">RECHAZADO</option>
      </React.Fragment>
    );
  }

  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== 'undefined') {
      if (typeof content === 'object' && content !== null && content.key) {
        return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
      }
      return String(content).toLowerCase().includes(filter.value.toLowerCase());
    }
    return true;
  };

  handleTypeRequest = (e, {value}) => {
    const {startDate, endDate} = this.state;
    const start = moment(startDate, DATEFORMAT).format(dateFormat);
    const end = moment(endDate, DATEFORMAT)
      .add(1, 'day')
      .format(dateFormat);
    this.setState({'typeRequest': value});


    this.props.getListVehCerticate(start, end, value);
  }


  render() {
    const {columns, startDate, endDate, typeRequest} = this.state;
    const {vehicles, excel, loading} = this.props;
    
    if (loading) {
      return <Loader />;
    }

    return (
      <div>
        <Card raised fluid>
          <div className="tcc-header-list">
            <HeaderLogo title={'Toyota certificados'} />
            <div className="tcc-header-controls">
              <div className="mr-2">
                <label htmlFor="select-type">Tipo de Solicitud</label>
                <Select
                  value={typeRequest}
                  onChange={this.handleTypeRequest}
                  name="select-type"
                  placeholder='Tipo de Solicitud'
                  options={OPTIONS_TYPE_REQUEST} />
              </div>
              <div>
                <label htmlFor="range-type-vehicle">Rango de fechas</label>
                <CalendarAirBnb
                  name="range-type-vehicle"
                  startDate={startDate}
                  endDate={endDate}
                  handleDatesChange={this.handleDatesChange}
                  showLabel={false}
                  displayFormatCustom='DD-MM-YYYY'
                  text={'Filtrar por fechas'}
                />
              </div>
              <div>
                <label htmlFor="btn-excel">Descarga Listado</label>
                {/* /api/files exige token: se descarga con downloadFile, no con un enlace directo */}
                <Button name="btn-excel" size={'small'} color='green' disabled={!excel}
                  onClick={() => downloadFile(excel)}>
                  Descargar excel
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid style={{'maxHeight': '35rem', 'overflow': 'auto'}}>
          <ListTccTable columns={columns} data={vehicles || []} />
        </Card>
      </div>
    );
  }
}

const {getListVehCerticate, getExcelReportCertificate, getPdfCertificate,
  clearPdf, getCertificateOwner, clearPdfOwner, getCpoLabel, clearCpoLabel, withRouter} = Actions;

const mapStateToProps = (state, ownProps) => {
  return {
    'vehicles': state.listVehicleCertification.vehicles,
    'loading': state.listVehicleCertification.loading,
    'excel': state.listVehicleCertification.excel,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'pdf': state.pdfCertificate.pdf,
    'idRequest': state.pdfCertificate.id,
    'idLabel': state.cpoLabel.id,
    'loadingLabel': state.cpoLabel.loading,
    'cpoLabel': state.cpoLabel.label,
    'loadingPdf': state.pdfCertificate.loadingPdf,
    'pdfCertificate': state.certificateOwner.certificate,
    'idRequestCertificate': state.certificateOwner.id,
    'loadingCertificate': state.certificateOwner.loading,
  };
};

export default withRouter(connect(
  mapStateToProps,
  {getListVehCerticate, getExcelReportCertificate,
    getPdfCertificate, getCertificateOwner, clearPdf,
    clearPdfOwner, getCpoLabel, clearCpoLabel}
)(ListVehiclesCertification));
